<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div class="container-fluid m-0 p-0">
            <div class="container-fluid m-0 p-0">
                <div class="top-card">
                    <div style="padding: 10px; margin: 5px">
                        <div class="main-heading">
                            <h1>Upload To Live</h1>
                        </div>
                    </div>
                </div>
            </div>


            <div class="card" style="margin: 16px;border-radius: 10px;">

                <div class="">
                    <div class="row">
                        <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                            <p class="my-auto ml-3" style="font-size: 20px;font-weight: 600;">Enter The Molecule</p>
                        </div>

                        <div class="col-5 col-md-5 col-sm-12" style="margin: 10px;">
                            <i class="fa fa-search icon" style="margin-right: 10px;"></i>
                            <input class="w-75" placeholder="Enter the Molecule Name" [(ngModel)]="searchValue"
                                (keydown.enter)="searchMolecule()" autofocus>
                        </div>

                        <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
                            <button type="button" class="btn btn-light" (click)="searchMolecule()">Submit</button>
                        </div>

                        <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                            <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
                                [style]="{'width':'100%','font-size':'12px'}" optionLabel="name"
                                placeholder="Select NDA" (onChange)="getData()" *ngIf="subMolecule">
                            </p-dropdown>

                        </div>

                        <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
                            <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
                        </div>

                    </div>
                </div>
            </div>

            <table class="table table-bordered" id="excel-table" style="margin: 20px;">
                <tbody>
                    <tr>
                        <td>Brand Name/Proprietary Name</td>
                        <td>{{ DragData['Brand Name/Proprietary Name'] }}</td>
                    </tr>
                    <tr>
                        <td style="width: 60px;">NDA Number</td>
                        <td>{{ DragData['NDA number'] }}</td>
                    </tr>
                    <tr>
                        <td>Active Ingredient</td>
                        <td>{{ DragData['Active Ingredient'] }}</td>
                    </tr>
                    <tr>
                        <td>Strengths (mg)</td>
                        <td>
                            <ul>
                                <li *ngFor="let strength of DragData['Strengths (mg)']">{{ strength }}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>Route of Administration</td>
                        <td>{{ DragData['Route of Administration'] }}</td>
                    </tr>
                    <tr>
                        <td>Dosage Forms</td>
                        <td>{{ DragData['Dosage forms'] }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" style="text-align: center;">
                            <button *ngIf="showUploadButton" class="btn btn-primary" (click)="showConfirmDialog()"
                                icon="pi pi-external-link" label="Show">Upload</button>
                            <p-dialog header="Are you sure?" [(visible)]="showConfirmationDialog"
                                [style]="{width: '25vw'}">
                                <p-footer>
                                    <button type="button" pButton icon="pi pi-check" label="Yes"
                                        (click)="onConfirm(DragData['Brand Name/Proprietary Name'],DragData['NDA number'])"></button>
                                    <button type="button" pButton icon="pi pi-times" label="No"
                                        (click)="onCancel()"></button>
                                </p-footer>
                            </p-dialog>
                        </td>
                    </tr>


                </tbody>
            </table>
        </div>
    </ng-container>
</div>